

import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcOverlayModule } from 'mwc/core/overlay';
import { MwcToolTipModule } from 'mwc/tooltip';

import { MwcPopoverComponent, MwcPopoverDirective } from './popover';

@NgModule({
  exports: [MwcPopoverDirective, MwcPopoverComponent],
  declarations: [MwcPopoverDirective, MwcPopoverComponent],
  imports: [
    BidiModule,
    CommonModule,
    OverlayModule,
    MwcOutletModule,
    MwcOverlayModule,
    MwcNoAnimationModule,
    MwcToolTipModule
  ]
})
export class MwcPopoverModule {}
